import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
const debug = process.env.NODE_ENV !== "production";

// 获取浏览器语言
function detectLang() {
    const lang = navigator.language || navigator.userLanguage; // 兼容性更好
    if (lang.startsWith("zh")) return "zh-CN";
    if (lang.startsWith("ko")) return "ko-KR";
    if (lang.startsWith("en")) return "en-US";
    return "en-US"; // 默认值
}

const state = {
    lang: detectLang(),
    loveLoading: false,
    muted: false,
};

const mutations = {
    updateLang(state, value) {
        state.lang = value;
    },
    updateLoveLoading(state, value) {
        state.loveLoading = value;
    },
    updateMuted(state, value) {
        state.muted = value;
    },
};
const actions = {};

export default createStore({
    state,
    mutations,
    actions,
    strict: debug,
    plugins: [createPersistedState()],
});
